module.exports = __webpack_public_path__ + "img/ofs-i-anquan.70071d26.png";